import React, { useState } from "react";
import { useQuery } from "@apollo/client";

import LocationList from "../components/LocationList";
import Pagination from "../components/Pagination";
import CardSkeletonGrid from "../components/Skeleton";
import { GET_LOCATIONS } from "../graphql/queries";
import { Location, PageInfo } from "../types";

interface LocationsData {
  locations: {
    info: PageInfo;
    results: Location[];
  };
}

const LocationsPage: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  // The query used to fetch page 1 only, so 106 of the 126 locations were
  // simply unreachable.
  const { loading, error, data } = useQuery<LocationsData>(GET_LOCATIONS, {
    variables: { page: currentPage },
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-white">Locations</h1>
        <p className="mt-1 text-sm text-slate-400">
          {data ? `${data.locations.info.count} known locations` : "Loaded over GraphQL"}
        </p>
      </header>

      {loading ? (
        <CardSkeletonGrid count={8} />
      ) : error ? (
        <p className="rounded-lg border border-red-500/30 bg-red-500/10 p-4 text-red-300">
          Could not load locations: {error.message}
        </p>
      ) : (
        <>
          <LocationList locations={data?.locations.results ?? []} />
          <Pagination
            currentPage={currentPage}
            totalPages={data?.locations.info.pages ?? 1}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </div>
  );
};

export default LocationsPage;
